module.exports = __webpack_public_path__ + "img/61.bde97bc9.jpg";